@if (wide) {
<!--
		The full-width arrangement, for a page that puts this card on a row of its
		own under the tier cards: the offer (price, dial, button) on the right, the
		description and the bullets in columns on the left. It is not part of the
		plans subgrid, so none of the seven-row rules below apply to it.
	-->
<lo-card [heading]="plan.title" [headingLevel]="2">
	<div class="wide">
		<div class="wide__info">
			<p class="plan-sub lo-type-text-sm">{{ subtitle }}</p>
			<ul class="features features--columns">
				@for (feature of plan.features; track $index) {
				<li class="feature lo-type-text-sm">
					<lo-icon name="check" [size]="12"></lo-icon>
					{{ feature }}
				</li>
				}
			</ul>
			@if (plan.footer_note) {
			<p class="footer-note lo-type-text-sm">{{ plan.footer_note }}</p>
			}
		</div>
		<div class="wide__offer">
			<span class="price-value lo-type-heading-1">
				{{ plan.price_label }}
			</span>
			<p class="price-note lo-type-text-sm-medium">{{ priceNote }}</p>
			@if (dialLabel) {
			<span class="dial-label lo-type-label-caps">{{ dialLabel }}</span>
			} @if (dialValue) {
			<span class="dial-static lo-type-text-md-semibold">
				{{ dialValue }}
			</span>
			}
			<button
				lo-button
				variant="secondary"
				type="button"
				block
				(click)="onContact()"
			>
				{{ plan.cta_label }}
			</button>
		</div>
	</div>
</lo-card>
} @else {
<!--
	The same SEVEN grid rows as app-plan-card, in the same order: head (the
	card's own header), subtitle, price, price-note, dial, button, features.
	This card sits in the same subgrid as the three tier cards, so a row more or
	fewer here takes every row after it off the line it shares with them. See
	the class comment.
-->
<lo-card [heading]="plan.title" [headingLevel]="2">
	<p class="plan-sub lo-type-text-sm">{{ subtitle }}</p>

	<div class="plan-price">
		<span class="price-value lo-type-heading-1">
			{{ plan.price_label }}
		</span>
	</div>

	<p class="price-note lo-type-text-sm-medium">{{ priceNote }}</p>

	<div class="plan-dial">
		@if (dialLabel) {
		<span class="dial-label lo-type-label-caps">{{ dialLabel }}</span>
		} @if (dialValue) {
		<span class="dial-static lo-type-text-md-semibold">
			{{ dialValue }}
		</span>
		}
	</div>

	<button
		lo-button
		variant="secondary"
		type="button"
		block
		(click)="onContact()"
	>
		{{ plan.cta_label }}
	</button>

	<div class="plan-body">
		<ul class="features">
			@for (feature of plan.features; track $index) {
			<li class="feature lo-type-text-sm">
				<lo-icon name="check" [size]="12"></lo-icon>
				{{ feature }}
			</li>
			}
		</ul>

		@if (plan.footer_note) {
		<p class="footer-note lo-type-text-sm">{{ plan.footer_note }}</p>
		}
	</div>
</lo-card>

}
